import Layout from '@/views/sector/Layout.vue';

export default {
    path: '/sector',
    component: Layout,
    children: [
        { path: 'summary', component: () => import('@/views/sector/Summary.vue') },
        { path: 'pulse', component: () => import('@/views/sector/Pulse.vue') },
        { path: 'add', component: () => import('@/views/sector/AddSector.vue') },
    ]
};
